import { css } from 'linaria';
export const iconStyle = "i1qqph0t";

require("./_iconStyle.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./_iconStyle.js");